import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import React, { useState, useEffect } from 'react';
import Button from "../../../shared/components/atoms/button/button";
import InputNumber from "../../../shared/components/atoms/input-number/input-number";
import GenericModal from '../../../shared/components/modals/generic-modal/generic-modal';
import FormatNumber from '../../../shared/utils/formatNumber';
import { siteUrl } from '../../../shared/utils/siteUrl';
import './modal-prize-item.scss';

const ModalPrizeItem = props => {

  const { prize, setModalClose, prizeSize } = props;
  const [quantity, setQuantity] = useState(1);
  const [beforeQuantity, setBeforeQuantity] = useState(1);
  const [sizePrize, setSizePrize] = useState("S");

  const whatCanWinLink = siteUrl + '/mis-puntos/que-puedo-ganar'
  const myCartLink = siteUrl + '/mis-puntos/mi-carrito'

  useEffect(() => {
    var body = document.getElementsByTagName("body")[0];
    var html = document.getElementsByTagName("html")[0];
    body.classList.add("overflow-body-hidden");
    html.classList.add("overflow-body-hidden");
  }, [])

  const handleSizeChange = (size) => {
    var prizes = JSON.parse(localStorage.getItem('USER_PRIZES'));
    setSizePrizeLocal(prizes, prize.codigoDePremio, size);
    localStorage.setItem('USER_PRIZES', JSON.stringify(prizes));
    setSizePrize(size)
  }

  const handleQuantityChange = (value) => {
    var prizes = JSON.parse(localStorage.getItem('USER_PRIZES'));

    if (value >= 1) {
      setQuantityPrize(prizes, prize.codigoDePremio, value);
      localStorage.setItem('USER_PRIZES', JSON.stringify(prizes));
    }

    setQuantity(value);
  }

  const setQuantityPrize = (array, valueFilter, value) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].codigoDePremio === valueFilter) {

        if (value > beforeQuantity)
          array[i].cantidad++
        else if (value < beforeQuantity)
          array[i].cantidad--

        setBeforeQuantity(value)
        break;
      }
    }
  }
  const setSizePrizeLocal = (array, valueFilter, size) => {
    for (let i = 0; i < array.length; i++) {
      if (array[i].codigoDePremio === valueFilter) {
        array[i].size = size
        break
      }
    }
  }


  return (
    <GenericModal>
      <span
        onClick={setModalClose}
        className="icon2-close f-icon f-icon-close-modal"
      />
      <div className="f-modal-prize-item-container">
        <div className="f-modal-prize-item-container-title">
          <h1>Agrega este producto</h1>
        </div>
        <div className="f-modal-prize-item-container-wrap">
          <div className="f-modal-prize-item-container-wrap-img">
            <img src={prize.imagenDelPremioCompleta.file.url}
              alt={prize.imagenDelPremioCompleta.description} />
          </div>
          <div className="f-modal-prize-item-container-wrap-info">
            <h1> {prize.nombreDelBono} </h1>
            <h2> {FormatNumber(prize.numeroDePuntos)} puntos</h2>
            <div className="f-modal-prize-item-container-wrap-info-quantity">
              <p><b>Cantidad</b></p>
              <InputNumber
                onChange={handleQuantityChange}
                value={1}
                maxValue={99}
              />
            </div>
            {prizeSize[0].size && <div className="f-modal-prize-item-container-wrap-info-quantity">
              <p><b>Talla:</b></p>
              {prizeSize.map((prize, key) =>
                <div className={sizePrize === prize.size ? "f-modal-prize-item-container-wrap-info-size active" : "f-modal-prize-item-container-wrap-info-size"}
                  key={key}
                  onClick={() => handleSizeChange(prize.size)}
                >{prize.size}</div>
              )}
            </div>

            }
            {documentToReactComponents(prize.descripcionDelBono.json)}
          </div>
        </div>
        <div className="f-my-cart-summary">
          <span className="f-curve" />
          <div className="f-my-cart-summary-container">
            {prizeSize[0].size && <p className="f-modal-prize-item-container-wrap-info-size-copy ">Recuerda que sólo puedes elegir una talla por cada redención. Si quieres redimir este producto en varias tallas deberás hacer varias redenciones.  </p>}
            <div className="f-my-cart-summary-container-info">
              <p className="f-points-accumulation-title">Premios agregados</p>
              <span className="f-dots" />
              <p className="f-points-accumulation"> {quantity} </p>
            </div>
            <div className="f-my-cart-summary-container-info">
              <p className="f-points-total-title">Total de puntos</p>
              <span className="f-dots" />
              <p className="f-points-total">{FormatNumber(quantity * prize.numeroDePuntos)}</p>
            </div>
          </div>
        </div>
        <div className="f-section-options">
          <div className="f-section-options-wrap">
            <Button className="fourth-pink" title="Seguir agregando" onClick={(e) => { e.preventDefault(); window.location = whatCanWinLink }} />
            <Button className="primary-pink" title="Ir a mi carrito" onClick={(e) => { e.preventDefault(); window.location = myCartLink }} />
          </div>
        </div>
      </div>
    </GenericModal>
  )
}

export default ModalPrizeItem;
